
import { Link } from 'react-router-dom';

export default function DrugFoodInteractions() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Article Header */}
      <section className="py-16 bg-gradient-to-br from-yellow-50 to-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-full flex items-center justify-center mr-4">
                <i className="ri-user-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-teal-600 font-semibold">ビースト君</p>
                <p className="text-gray-500 text-sm">2025年10月7日</p>
              </div>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">薬の飲み合わせで注意すべき食べ物10選【薬剤師監修】</h1>
            <p className="text-xl text-gray-600">薬と食べ物の相互作用について、薬剤師が詳しく解説します</p>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/6307c3102823dc936c5955d446743d09.jpg"
              alt="薬と食べ物の飲み合わせ"
              className="w-full max-w-2xl h-80 object-cover object-top rounded-xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 mb-8">
              こんにちは、ビースト君です！薬を飲むときに「水で飲んでください」と言われることが多いですが、
              実は食べ物との組み合わせによって薬の効果が変わることがあります。筋トレでも食事のタイミングが大切なように、
              薬も食べ物との相性を知っておくことが重要です。今日は特に注意が必要な食べ物10選をご紹介します。
            </p>

            <div className="bg-red-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">⚠️ 重要な注意点</h3>
              <p className="text-gray-700">
                薬と食べ物の相互作用は個人差があります。心配な症状が現れた場合は、
                すぐに医師や薬剤師に相談してください。自己判断で薬を中止することは避けましょう。
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬の飲み合わせで注意すべき食べ物10選</h2>
            
            <div className="space-y-8 mb-12">
              {/* 1. グレープフルーツ */}
              <div className="bg-orange-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-orange-800 mb-4 flex items-center">
                  <span className="bg-orange-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">1</span>
                  グレープフルーツ・グレープフルーツジュース
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• カルシウム拮抗薬（血圧の薬）</li>
                      <li>• スタチン系薬剤（コレステロールの薬）</li>
                      <li>• 免疫抑制薬</li>
                      <li>• 一部の抗不安薬</li>
                      <li>• 一部の抗がん剤</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 薬の血中濃度が上昇</li>
                      <li>• 副作用が強く現れる</li>
                      <li>• 血圧の過度な低下</li>
                      <li>• 筋肉痛や肝機能障害</li>
                      <li>• 効果が24時間以上持続</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    該当する薬を服用中は、グレープフルーツ及びグレープフルーツジュースを完全に避ける。
                    他の柑橘類（オレンジ、レモンなど）は通常問題ありません。
                  </p>
                </div>
              </div>

              {/* 2. 牛乳・乳製品 */}
              <div className="bg-blue-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-blue-800 mb-4 flex items-center">
                  <span className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">2</span>
                  牛乳・乳製品（チーズ、ヨーグルトなど）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• テトラサイクリン系抗生物質</li>
                      <li>• ニューキノロン系抗生物質</li>
                      <li>• 鉄剤</li>
                      <li>• 甲状腺ホルモン薬</li>
                      <li>• ビスホスホネート系薬剤</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• カルシウムが薬と結合</li>
                      <li>• 薬の吸収が大幅に低下</li>
                      <li>• 治療効果の減弱</li>
                      <li>• 感染症治療の失敗</li>
                      <li>• 貧血の改善遅延</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    薬の服用前後2時間は乳製品を避ける。水で服用し、時間をあけてから乳製品を摂取する。
                    カルシウム強化食品も同様に注意が必要です。
                  </p>
                </div>
              </div>

              {/* 3. お茶・コーヒー */}
              <div className="bg-green-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-green-800 mb-4 flex items-center">
                  <span className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">3</span>
                  お茶・コーヒー（タンニン・カフェイン含有飲料）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 鉄剤</li>
                      <li>• 一部の精神科薬</li>
                      <li>• アルカロイド系薬剤</li>
                      <li>• 気管支拡張薬</li>
                      <li>• 中枢神経刺激薬</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• タンニンが薬と結合し吸収阻害</li>
                      <li>• カフェインとの相互作用</li>
                      <li>• 興奮作用の増強</li>
                      <li>• 不眠や動悸</li>
                      <li>• 鉄欠乏性貧血の改善遅延</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    薬の服用時は水を使用し、お茶やコーヒーは服用前後1-2時間避ける。
                    特に鉄剤服用時は、ビタミンCを含む飲み物（オレンジジュースなど）が吸収を促進します。
                  </p>
                </div>
              </div>

              {/* 4. アルコール */}
              <div className="bg-red-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-red-800 mb-4 flex items-center">
                  <span className="bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">4</span>
                  アルコール（ビール、日本酒、ワインなど）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 睡眠薬・抗不安薬</li>
                      <li>• 抗うつ薬</li>
                      <li>• 痛み止め</li>
                      <li>• 抗てんかん薬</li>
                      <li>• 糖尿病薬</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 中枢神経抑制作用の増強</li>
                      <li>• 過度の眠気や意識障害</li>
                      <li>• 呼吸抑制の危険</li>
                      <li>• 低血糖のリスク増加</li>
                      <li>• 肝機能への負担増加</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    薬物治療中は原則として禁酒。特に中枢神経系に作用する薬では生命に関わる危険があります。
                    医師に相談なく飲酒することは絶対に避けてください。
                  </p>
                </div>
              </div>

              {/* 5. 納豆・青汁 */}
              <div className="bg-purple-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-purple-800 mb-4 flex items-center">
                  <span className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">5</span>
                  納豆・青汁（ビタミンK豊富な食品）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• ワルファリン（抗凝固薬）</li>
                      <li>• その他のクマリン系薬剤</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• ビタミンKが薬効を阻害</li>
                      <li>• 血液凝固能の回復</li>
                      <li>• 血栓形成のリスク増加</li>
                      <li>• 脳梗塞や心筋梗塞の危険</li>
                      <li>• PT-INR値の低下</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    ワルファリン服用中は納豆を完全に避ける。青汁、クロレラ、緑黄色野菜の大量摂取も注意。
                    ビタミンK含有量の多い食品は医師と相談して摂取量を調整してください。
                  </p>
                </div>
              </div>

              {/* 6. セントジョーンズワート */}
              <div className="bg-yellow-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-yellow-800 mb-4 flex items-center">
                  <span className="bg-yellow-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">6</span>
                  セントジョーンズワート（ハーブサプリメント）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 抗うつ薬</li>
                      <li>• 免疫抑制薬</li>
                      <li>• 抗HIV薬</li>
                      <li>• 経口避妊薬</li>
                      <li>• 抗がん剤</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 薬物代謝酵素の誘導</li>
                      <li>• 薬の血中濃度低下</li>
                      <li>• 治療効果の減弱</li>
                      <li>• 臓器移植の拒絶反応</li>
                      <li>• 避妊効果の低下</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    処方薬服用中はセントジョーンズワート含有サプリメントを避ける。
                    ハーブ系サプリメントを使用する際は必ず医師・薬剤師に相談してください。
                  </p>
                </div>
              </div>

              {/* 7. 高脂肪食 */}
              <div className="bg-indigo-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-indigo-800 mb-4 flex items-center">
                  <span className="bg-indigo-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">7</span>
                  高脂肪食（揚げ物、脂っこい食事）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 脂溶性ビタミン</li>
                      <li>• 一部の抗真菌薬</li>
                      <li>• 免疫抑制薬</li>
                      <li>• 一部の抗HIV薬</li>
                      <li>• 脂溶性薬剤全般</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 薬の吸収が増加</li>
                      <li>• 血中濃度の上昇</li>
                      <li>• 副作用の増強</li>
                      <li>• 効果の予測困難</li>
                      <li>• 胃腸への負担増加</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    該当する薬の服用時は高脂肪食を避け、軽めの食事にする。
                    薬によっては食事の内容により服用タイミングを調整する必要があります。
                  </p>
                </div>
              </div>

              {/* 8. 甘草含有食品 */}
              <div className="bg-pink-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-pink-800 mb-4 flex items-center">
                  <span className="bg-pink-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">8</span>
                  甘草含有食品（甘草湯、一部の菓子類）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 利尿薬</li>
                      <li>• 強心薬（ジギタリス）</li>
                      <li>• 降圧薬</li>
                      <li>• 甘草含有漢方薬</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 偽アルドステロン症</li>
                      <li>• カリウム値の低下</li>
                      <li>• 血圧上昇</li>
                      <li>• むくみの出現</li>
                      <li>• 不整脈のリスク</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    甘草含有の漢方薬や健康食品の重複摂取を避ける。
                    血圧や心疾患の薬を服用中は甘草製品の摂取について医師に相談してください。
                  </p>
                </div>
              </div>

              {/* 9. 炭酸飲料 */}
              <div className="bg-cyan-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-cyan-800 mb-4 flex items-center">
                  <span className="bg-cyan-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">9</span>
                  炭酸飲料（コーラ、炭酸水など）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 腸溶錠</li>
                      <li>• 徐放錠</li>
                      <li>• 一部の抗生物質</li>
                      <li>• 鉄剤</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 胃内pHの変化</li>
                      <li>• 薬の溶解性変化</li>
                      <li>• 吸収の変動</li>
                      <li>• 徐放性の破綻</li>
                      <li>• 効果の不安定化</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    薬の服用時は常温の水を使用する。炭酸飲料での服用は避け、
                    特に特殊な剤形の薬（腸溶錠、徐放錠など）では注意が必要です。
                  </p>
                </div>
              </div>

              {/* 10. チラミン含有食品 */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <span className="bg-gray-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm mr-3">10</span>
                  チラミン含有食品（チーズ、ワイン、発酵食品）
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">🚫 影響を受ける薬</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• MAO阻害薬</li>
                      <li>• 一部の抗うつ薬</li>
                      <li>• 抗パーキンソン病薬</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">⚡ 起こりうる影響</h4>
                    <ul className="text-gray-600 text-sm space-y-1">
                      <li>• 急激な血圧上昇</li>
                      <li>• 高血圧クリーゼ</li>
                      <li>• 頭痛、動悸</li>
                      <li>• 脳出血のリスク</li>
                      <li>• 生命に関わる危険</li>
                    </ul>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4 mt-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💡 対策</h4>
                  <p className="text-gray-600 text-sm">
                    MAO阻害薬服用中は熟成チーズ、赤ワイン、発酵食品を避ける。
                    該当する薬を処方された際は、医師から詳しい食事指導を受けてください。
                  </p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">薬と食べ物の相互作用を避けるための基本ルール</h2>
            
            <p className="text-gray-700 mb-6">
              筋トレでも基本フォームが大切なように、薬の服用にも基本ルールがあります。
              これらを守ることで、多くの相互作用を避けることができます。
            </p>

            <div className="bg-teal-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">基本的な服用ルール</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">💧 水で服用</h4>
                  <p className="text-gray-600 text-sm">コップ1杯程度の常温の水で服用する</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">⏰ 時間を守る</h4>
                  <p className="text-gray-600 text-sm">食前・食後・食間の指示を正確に守る</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📋 記録をつける</h4>
                  <p className="text-gray-600 text-sm">服用した薬と食べた物を記録する</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🗣️ 相談する</h4>
                  <p className="text-gray-600 text-sm">不明な点は必ず薬剤師に相談する</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">症状が現れた時の対処法</h2>
            
            <p className="text-gray-700 mb-6">
              薬と食べ物の相互作用により何らかの症状が現れた場合の対処法をお伝えします。
              早期の対応が重要です。
            </p>

            <div className="bg-red-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-red-800 mb-4">緊急時の対処法</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">🚨 すぐに医療機関を受診すべき症状</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 急激な血圧上昇（頭痛、めまい、動悸）</li>
                    <li>• 呼吸困難、意識障害</li>
                    <li>• 激しい腹痛、嘔吐</li>
                    <li>• アレルギー症状（発疹、かゆみ、腫れ）</li>
                    <li>• 異常な出血</li>
                  </ul>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">📞 薬剤師に相談すべき症状</h4>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• 軽度の胃腸症状</li>
                    <li>• 薬の効果が感じられない</li>
                    <li>• 普段と違う体調変化</li>
                    <li>• 食事との関連が疑われる症状</li>
                  </ul>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">よくある質問と回答</h2>
            
            <div className="bg-gray-50 rounded-xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Q&A</h3>
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 薬を飲んだ後、どのくらい時間をあければ注意食品を摂取できますか？</h4>
                  <p className="text-gray-600 text-sm">A: 薬によって異なりますが、一般的には2-4時間程度です。グレープフルーツなど影響が長時間続くものは24時間以上避ける必要があります。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: サプリメントも薬との相互作用がありますか？</h4>
                  <p className="text-gray-600 text-sm">A: はい、あります。特にハーブ系サプリメントは注意が必要です。サプリメントも含めて全て薬剤師に報告してください。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 少量なら大丈夫ですか？</h4>
                  <p className="text-gray-600 text-sm">A: 相互作用は量に関係なく起こる場合があります。特にグレープフルーツやアルコールは少量でも影響が出ることがあるので避けてください。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 薬をやめれば好きな物を食べられますか？</h4>
                  <p className="text-gray-600 text-sm">A: 自己判断での薬の中止は危険です。食事制限が辛い場合は、医師と相談して薬の変更や調整を検討しましょう。</p>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Q: 家族の薬と同じ注意事項ですか？</h4>
                  <p className="text-gray-600 text-sm">A: 薬が違えば注意事項も異なります。必ず自分の薬について個別に確認し、他人の情報に頼らないでください。</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-6">まとめ</h2>
            
            <p className="text-gray-700 mb-6">
              薬と食べ物の相互作用は、薬の効果や安全性に大きく影響します。
              正しい知識を持って、安全で効果的な薬物治療を受けましょう。
            </p>

            <div className="bg-teal-50 rounded-xl p-6">
              <h3 className="text-xl font-semibold text-teal-800 mb-4">ビースト君からのアドバイス</h3>
              <p className="text-gray-700">
                薬と食べ物の相互作用も筋トレと同じで、正しい知識があれば安全に管理できます。
                「これくらい大丈夫」という自己判断は禁物です。分からないことがあったら、
                遠慮なく薬剤師に相談してください。お薬手帳を活用して、服用している薬と
                食べた物を記録することも大切です。みんなで安全な薬物治療を心がけましょう！💪💊
              </p>
            </div>
          </div>
        </div>
      </article>

      {/* Related Articles */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">関連記事</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <Link to="/beast-blog/medicine-not-working" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medication%20effectiveness%20issues%2C%20professional%20healthcare%20setting%20with%20medicine%20bottles%20and%20warning%20charts%2C%20educational%20illustration%20showing%20various%20factors%20affecting%20drug%20efficacy%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background&width=400&height=250&seq=beast-medicine-not-working-related&orientation=landscape"
                alt="薬が効かない原因"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬が効かないときの原因5選｜飲み方・生活習慣・相互作用をチェック</h3>
                <p className="text-gray-600">薬の効果が感じられない時に確認すべきポイントを薬剤師が詳しく解説します</p>
              </div>
            </Link>
            <Link to="/beast-blog/effective-medication" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden cursor-pointer">
              <img 
                src="https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medicine%20timing%20and%20proper%20medication%20usage%2C%20educational%20illustration%20with%20clock%20and%20medicine%20schedule%2C%20friendly%20cartoon%20style%2C%20professional%20healthcare%20setting&width=400&height=250&seq=beast-medication-timing-related3&orientation=landscape"
                alt="薬の効果的な飲み方"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">薬の効果的な飲み方とタイミング</h3>
                <p className="text-gray-600">薬の効果を最大限に引き出すための正しい服用方法について解説します</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">ビースト君ブログ</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/beast-blog" className="hover:text-white cursor-pointer">記事一覧</Link></li>
                <li><Link to="/beast-blog/multidisciplinary-collaboration" className="hover:text-white cursor-pointer">多職種連携</Link></li>
                <li><Link to="/beast-blog/winter-mental-health" className="hover:text-white cursor-pointer">メンタルヘルス</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
